import React from 'react';
import { Mail, CreditCard, Download } from 'lucide-react';
export function HowItWorks() {
  return <section className="bg-white py-6 px-4" data-id="element-97">
      <div className="max-w-4xl mx-auto text-center" data-id="element-98">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-99">
          🔽 ¿Cómo recibís el material?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-100">
          <div className="bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-101">
            <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3 text-blue-600" data-id="element-102">
              <Mail className="w-5 h-5" data-id="element-103" />
            </div>
            <h3 className="font-bold text-lg mb-2" data-id="element-104">Paso 1</h3>
            <p className="text-gray-600" data-id="element-105">
              Realizás la compra e ingresás tu correo.
            </p>
          </div>

          <div className="bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-106">
            <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3 text-green-600" data-id="element-107">
              <CreditCard className="w-5 h-5" data-id="element-108" />
            </div>
            <h3 className="font-bold text-lg mb-2" data-id="element-109">Paso 2</h3>
            <p className="text-gray-600" data-id="element-110">Finalizás el pago de forma segura.</p>
          </div>

          <div className="bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-111">
            <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3 text-purple-600" data-id="element-112">
              <Download className="w-5 h-5" data-id="element-113" />
            </div>
            <h3 className="font-bold text-lg mb-2" data-id="element-114">Paso 3</h3>
            <p className="text-gray-600" data-id="element-115">
              Recibís automáticamente el link de descarga.
            </p>
          </div>
        </div>

        <p className="mt-4 text-sm text-gray-500 bg-yellow-50 inline-block px-4 py-2 rounded-lg border border-yellow-100" data-id="element-116">
          ⚠️ Si no lo ves en tu bandeja principal, revisá spam.
        </p>
      </div>
    </section>;
}